/**
 * portalAuth – Token-Verwaltung + fetch-Wrapper für die Tool-Seiten.
 *
 * Funktioniert in BEIDEN Welten:
 *  - Tools-Portal (tools.sijelly.com): toolToken (localStorage + Cookie
 *    "tool_token" — der Cookie ist nötig, damit report.html und dessen
 *    relative PDF-Links als Browser-Subrequests authentifiziert sind)
 *  - imho intern: Fallback auf das MA-Token aus localStorage
 */
import Cookies from "js-cookie";

const TOOL_TOKEN_KEY = "toolToken";

export function getToolToken() {
  return localStorage.getItem(TOOL_TOKEN_KEY) || "";
}

export function setToolToken(token) {
  localStorage.setItem(TOOL_TOKEN_KEY, token);
  Cookies.set("tool_token", token, { expires: 30 });
}

export function clearToolToken() {
  localStorage.removeItem(TOOL_TOKEN_KEY);
  Cookies.remove("tool_token");
}

/** Header für API-Calls: Tool-Token bevorzugt, sonst internes MA-Token. */
export function authHeaders() {
  const toolToken = getToolToken();
  if (toolToken) return { "X-Tool-Token": toolToken };
  const maToken = localStorage.getItem("maToken");
  if (maToken) return { "X-MA-Token": maToken };
  return {};
}

/** Query-Anhang für Links, die in neuem Tab geöffnet werden (report/xlsx). */
export function authQuery() {
  const toolToken = getToolToken();
  if (toolToken) return `tool_token=${encodeURIComponent(toolToken)}`;
  const maToken = localStorage.getItem("maToken");
  if (maToken) return `token=${encodeURIComponent(maToken)}`;
  return "";
}

/** fetch mit automatischen Auth-Headern (Optionen werden gemerged). */
export function pFetch(url, opts = {}) {
  const headers = { ...(opts.headers || {}), ...authHeaders() };
  return fetch(url, { ...opts, headers });
}
